import {
    apiRequest,
    penilaianCreate
} from "../../../../../services/adapters/kepegawaian/penilaianService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", penilaianCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository